<template>
  <th class="responsive-table__th responsive-th">
    <div class="responsive-th__content">
      <slot />
    </div>
  </th>
</template>

<script>
  export default {
    name: "RtTh"
  }
</script>

<style lang="scss">
.responsive-th{
  padding: 0;


  &__content{
    text-align: left!important;
    position: relative;
    vertical-align: bottom;
    padding: 10px 12px;
    background: transparent;
    font-weight: 600!important;
    color: rgba(var(--app-text-dark), 1);
    border-bottom: 0 solid rgba(0,0,0,.125);
    font-size: 1rem;
  }
}
</style>
